import { render, staticRenderFns } from "./subcontractor.vue?vue&type=template&id=19ba5e72&scoped=true"
import script from "./subcontractor.vue?vue&type=script&lang=js"
export * from "./subcontractor.vue?vue&type=script&lang=js"
import style0 from "./subcontractor.vue?vue&type=style&index=0&id=19ba5e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba5e72",
  null
  
)

export default component.exports